<template>
  <div>
    <el-select
        v-model="status"
        size="small"
        @change="onStatusChange">
      <el-option
          v-for="item in statuses"
          :key="item.id"
          :label="item.name_ru"
          :value="item.id">
      </el-option>
    </el-select>
<!--    <el-dialog
        :visible.sync="dialogVisible"
        append-to-body
        :show-close="false"
        :close-on-click-modal="false"
        custom-class="rejection-modal"
        @close="onDialogClose"
    >
      <el-form :model="form" :rules="form_rules" ref="Form">
        <el-form-item class="rejection-radios" label="Причина отказа" prop="status_change_reason">
          <el-radio-group v-model="rejectionReasonType">
            <el-radio :label="1">Ваша заявка оформлена неправильно, пожалуйста повторите</el-radio>
            <el-radio :label="2">Проживающим в г.Усть-Каменогорске общежитие не предоставляется</el-radio>
            <el-radio class="other-reason" :label="3">
              Другое:
              <el-divider direction="vertical"/>
              <el-input
                  :disabled="rejectionReasonType !== 3"
                  :rows="2"
                  type="textarea"
                  v-model="rejectionReasonOther">
              </el-input>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onDialogSubmit">Сохранить</el-button>
          <el-button @click="onDialogCancel">Отмена</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>-->

    <el-dialog
        :visible.sync="dialogVisible"
        append-to-body
        :show-close="false"
        :close-on-click-modal="false"
        custom-class="rejection-modal"
        @close="onDialogClose"
    >
      <el-form :model="form" :rules="form_rules" ref="Form">
        <el-form-item class="status-reason-radios" label="Причина изменения статуса" prop="status_change_reason">
          <el-radio-group v-model="formReasonType">
            <el-radio
                v-for="(reason, i) in formReasons"
                :key="i"
                :label="i"
                :value="reason">
              {{reason}}
            </el-radio>
            <el-radio class="other-reason" :label="'other'" :value="'other'">
              Другое:
              <el-divider direction="vertical"/>
              <el-input
                  class="other-reason-input"
                  @focus="() => {
                    formReasonType = 'other'
                  }"
                  :rows="3"
                  type="textarea"
                  v-model="statusChangeReasonOther">
              </el-input>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onDialogSubmit">Сохранить</el-button>
          <el-button @click="onDialogCancel">Отмена</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import adminApi from '@/api/admin'
import {actionTypes as adminActions} from "@/store/modules/admin";
import { Message } from 'element-ui';

export default {
  props: ['value', 'applicationId'],
  data(){
    return {
      status: null,
      statuses: [],
      rejectionStatusId: 2,
      rejectionReasonType: 'rejection_reason',
      repeatReasonStatusId: 3,
      repeatReasonType: 'repeat_reason',
      formReasons: {},
      formAvailableReasons: {
        //rejection reasons 1
        [this.rejectionStatusId]: [
          'Ваша заявка оформлена неправильно, пожалуйста повторите',
          'Проживающим в г.Усть-Каменогорске общежитие не предоставляется'
        ],
        //repeat reasons 3
        [this.repeatReasonStatusId]: [
          'Ваша заявка оформлена неправильно, пожалуйста повторите'
        ]
      },
      formReasonType: null,
      currentStatusId: null,
      //rejectionReasonOther: '',
      statusChangeReasonOther: '',
      dialogVisible: false,
      form: {
        status_change_reason: '',
      },
      form_rules: {
        status_change_reason: [
          { required: true, message: 'Введите причину изменения статуса', trigger: 'blur' }
        ],
      }
    }
  },
  mounted() {
    //this.rejectionReasonType = 1
    this.status = this.value
    this.formAvailableReasons = {
      //rejection reasons 1
      [this.rejectionStatusId]: [
        'Ваша заявка оформлена неправильно, пожалуйста повторите',
        'Проживающим в г.Усть-Каменогорске общежитие не предоставляется'
      ],
      //repeat reasons 3
      [this.repeatReasonStatusId]: [
        'Ваша заявка оформлена неправильно, пожалуйста повторите'
      ]
    }
    this.statuses = adminApi.getApplicationStatuses()
  },
  methods: {
    changeApplicationStatus(newStatus) {
      if (newStatus !== this.value) {
        let sendData = {}

        if(newStatus === this.rejectionStatusId || newStatus === this.repeatReasonStatusId) {
          sendData = this.form
        }

        this.$store.dispatch(adminActions.setApplicationStatus, {
          applicationId: this.applicationId,
          status: Number(newStatus),
          data: sendData
        })
        .then((response) => {
          if(response.data.is_message_sent === null || response.data.is_message_sent === true)
            this.$message({
              message: 'Статус заявки обновлен',
              type: 'success'
            })
          else if(response.data.is_message_sent === false)
            this.$message({
              message: 'Статус заявки обновлен. Сообщение на почту не было отправлено.',
              type: 'warning'
            })
          //this.$store.dispatch(adminActions.setNeedReload, {needReload: true})
        })
      }
    },
    onStatusChange(newStatus){
      if(newStatus === this.rejectionStatusId || newStatus === this.repeatReasonStatusId) {
        console.log('new status')
        console.log(newStatus)
        console.log(this.formAvailableReasons)

        this.form.status_change_reason = ''
        this.statusChangeReasonOther = ''
        this.currentStatusId = newStatus
        this.formReasonType = null

        this.dialogVisible = true

        this.formReasons = this.formAvailableReasons[newStatus]
      } else {
        this.changeApplicationStatus(newStatus)
      }
    },
    onDialogSubmit(){
      this.$refs.Form.validate((valid) => {
        if(valid){
          this.changeApplicationStatus(this.status)
          this.dialogVisible = false
        } else {
          return false
        }
      })
    },
    onDialogCancel(){
      this.dialogVisible = false
    },
    onDialogClose(){
      this.$refs.Form.resetFields()
      this.status = this.value
    }
  },
  watch: {
    value(val){
      this.status = val
    },
    formReasonType(val){
      console.log(val)
      if(val !== 'other'){
        this.form.status_change_reason = this.formAvailableReasons[this.currentStatusId][val]
      } else {
        this.form.status_change_reason = ''
      }
    },
    statusChangeReasonOther(val){
      this.form.status_change_reason = val
    }
  }
}
</script>